import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import VideoSection from '../components/VideoSection';
import ProductGrid from '../components/ProductGrid';
import TestimonialsSection from '../components/TestimonialsSection';
import LifeInsuranceQuestionnaire from '../components/LifeInsuranceQuestionnaire';
import ChatWidget from '../components/ChatWidget';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <VideoSection />
      <ProductGrid />
      <TestimonialsSection />
      <LifeInsuranceQuestionnaire />
      <Footer />
      <ChatWidget />
    </div>
  );
};

export default HomePage;